import { render, staticRenderFns } from "./DocumentSynthesisListItem.vue?vue&type=template&id=46b2dc9e"
import script from "./DocumentSynthesisListItem.vue?vue&type=script&lang=ts"
export * from "./DocumentSynthesisListItem.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSynthesisListItem.vue?vue&type=style&index=0&id=46b2dc9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports